import React from "react";

import { useGetExperiencesList } from "../../../../api/experiences-list/get-experiences-list";
import IgErrorBoundary from "../../../../components/Utils/IgErrorBoundary";
import Loading from "../../../../utils/Loading";

import { PersonalizationOverviewBody } from "./PersonalizationOverview.body";

export const PersonalizationOverviewRoute = () => {
  const personalizationsList = useGetExperiencesList({
    category: "personalization",
  });
  const experienceList = useGetExperiencesList({
    category: "experiment",
  });

  if (personalizationsList.isLoading || experienceList.isLoading) {
    return <Loading />;
  }
  if (!personalizationsList.isSuccess || !experienceList.isSuccess) {
    return null;
  }
  return (
    <IgErrorBoundary>
      <PersonalizationOverviewBody
        personalizationsList={personalizationsList.data.experiencesList}
        experienceList={experienceList.data.experiencesList}
      />
    </IgErrorBoundary>
  );
};
